import React from "react"
import { withPrefix } from "gatsby"

import Navbar from "./navbar"
import Footer from "./footer"
import CookiePolicy from "./cookie-policy"
import Helmet from "react-helmet"
import PropTypes from "prop-types"

const Layout = ({ children }) => (
  <>
    <Helmet>
      <script>
        {typeof window !== "undefined"
          ? (function (p, l, o, w, i, n, g) {
              if (!p[i]) {
                p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
                p.GlobalSnowplowNamespace.push(i)
                p[i] = function () {
                  ;(p[i].q = p[i].q || []).push(arguments)
                }
                p[i].q = p[i].q || []
                n = l.createElement(o)
                g = l.getElementsByTagName(o)[0]
                n.async = 1
                n.src = w
                g.parentNode.insertBefore(n, g)
              }
            })(
              window,
              document,
              "script",
              withPrefix("sp-v2.16.3.js"),
              "snowplow"
            )
          : null}
      </script>
    </Helmet>

    {typeof window !== "undefined" ? (
      <script>
        {window.snowplow("newTracker", "cf", "sp.sliceinsurance.com", {
          appId:
            window.location.host === "dev-www.sliceinsurance.com" ||
            window.location.host.includes("localhost")
              ? "sliceinsurance.com.dev"
              : "sliceinsurance.com.prd",
          contexts: {
            webPage: true,
          },
        })}
        {window.snowplow("trackPageView")}
        {window.snowplow("enableLinkClickTracking")}
        {window.snowplow("enableFormTracking")}
      </script>
    ) : null}

    <Navbar />
    {children}
    <Footer />
    <CookiePolicy />
    {/* Start of HubSpot Embed Code */}
    <script
      type="text/javascript"
      id="hs-script-loader"
      async
      defer
      src="//js.hs-scripts.com/1668259.js"
    ></script>
    {/* End of HubSpot Embed Code */}
  </>
)

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
